import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be later than Start Date.`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var startDate = args[0]
    if (startDate) {
      if (isAfter(removeTime(value), removeTime(startDate))) return false
      else return true
    } else return true
  } else return true
}

export default {
  getMessage,
  validate
}
